import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import Navbar from '../Navbar'

export default function Pay() {

  const { url } = useSelector(state => state)

  const [application, setApplication] = useState(null)
  const [paymentProperty, setPaymentProperty] = useState(null)

  const [defaultAmount, setDefaultAmount] = useState(0)
  const [selectedMonths, setSelectedMonths] = useState(1)

  const [loading, setLoading] = useState(true)
  const [paying, setPaying] = useState(false)

  const [error, setError] = useState('')




useEffect(() => {

  const token =
    localStorage.getItem(
      'access_token'
    )

  const headers = {
    Authorization:
      `Bearer ${token}`
  }

  const fetchData = async () => {

    try {
      setError('')
      const loanResponse = await axios.get(
        `${url}/auth/my-loan-application`,
        { headers }
      )

      const applicationData =
        loanResponse.data

      setApplication(
        applicationData
      )

      const hasActiveLoan =
        applicationData?.has_application &&
        applicationData?.status === 'active' &&
        applicationData?.loan


      if (!hasActiveLoan) {
        return
      }


      const [
        paymentResponse,
        defaultResponse
      ] = await Promise.all([

        axios.get(
          `${url}/pay/get-payment`,
          { headers }
        ),

        axios.get(
          `${url}/auth/get-default`,
          { headers }
        )

      ])


      setPaymentProperty(
        paymentResponse.data
      )


      setDefaultAmount(
        Number(
          defaultResponse.data.total_default
        ) || 0
      )


    } catch (err) {

  console.error(err)

  if (err.response?.status === 404) {

    setApplication({
      has_application: false,
      status: null,
      loan: null
    })

    setError('')
    return
  }

  setError(
    err.response?.data?.detail ||
    err.response?.data?.error ||
    'Unable to load payment information.'
  )

} finally {

      setLoading(false)

    }

  }


  fetchData()

}, [url])


  if (loading) {

    return (

      <div className="min-h-screen bg-slate-50 font-[Satoshi]">

        <Navbar />

        <main className="
          lg:ml-[15em]
          min-w-0
          min-h-screen
          flex-1
          bg-[#F7F9FC]
          px-5
          pb-10
          pt-24
          sm:px-6
          lg:px-8
          lg:pt-8
        ">

          <div className="
            mx-auto
            max-w-[1500px]
          ">

            <div className="
              bg-white
              border
              border-gray-200
              rounded-2xl
              p-8
              shadow-sm
            ">

              <div className="
                animate-pulse
                space-y-4
              ">

                <div className="
                  h-6
                  bg-gray-200
                  rounded
                  w-48
                " />

                <div className="
                  h-4
                  bg-gray-100
                  rounded
                  w-80
                  max-w-full
                " />

                <div className="
                  h-32
                  bg-gray-100
                  rounded-xl
                  mt-8
                " />

              </div>

            </div>

          </div>

        </main>

      </div>
    )
  }


  const hasActiveLoan =
    application?.has_application &&
    application?.status === 'active' &&
    application?.loan


  if (!hasActiveLoan) {

    return (

      <div className="min-h-screen bg-slate-50 font-[Satoshi]">

        <Navbar />

        <main className="
  lg:ml-[15em]
  min-w-0
  min-h-screen
  flex-1
  bg-[#F7F9FC]
  px-5
  pb-10
  pt-24
  sm:px-6
  lg:px-8
  lg:pt-8
">

  <div className="
    mx-auto
    max-w-[1500px]
  ">

    {/* PAGE HEADER */}

<div className="
  mb-6
  flex
  flex-col
  gap-4
  sm:mb-8
  sm:flex-row
  sm:items-end
  sm:justify-between
">

  <div>

    <p className="
      text-sm
      font-semibold
      text-green-600
    ">
      REPAYMENTS
    </p>

    <h1 className="
      mt-1
      text-2xl
      sm:text-3xl
      font-bold
      tracking-tight
      text-gray-900
    ">
      Make a payment
    </h1>

    <p className="
      mt-2
      text-sm
      leading-6
      text-gray-500
    ">
      Manage your RentHub repayments from here.
    </p>

  </div>

</div>

            <div className="
  max-w-xl
  bg-white
  border
  border-gray-200
  rounded-2xl
  shadow-sm
  p-8
">

              <div className="
                w-12
                h-12
                bg-green-50
                rounded-xl
                flex
                items-center
                justify-center
                mb-5
              ">

                <span className="
                  text-green-600
                  text-xl
                  font-bold
                ">
                  ₦
                </span>

              </div>

              <h1 className="
                text-2xl
                font-bold
                text-gray-900
              ">
                No active loan
              </h1>

              <p className="
                text-gray-500
                mt-2
                leading-6
              ">
                You don't currently have an active RentHub loan available for repayment.
              </p>

              {error && (

                <div className="
                  mt-5
                  bg-red-50
                  border
                  border-red-100
                  rounded-xl
                  p-4
                  text-sm
                  text-red-600
                ">
                  {error}
                </div>

              )}

            </div>

          </div>

        </main>

      </div>
    )
  }


  const loan = application.loan

  const monthlyPayment =
    Number(loan.monthly_repayment || 0)

  const outstandingBalance =
    Number(loan.outstanding_balance || 0)

  const installmentsLeft =
    Number(loan.installments_left || 0)

  const allowedMonths =
    Number(paymentProperty?.months || 0)

  const availableMonths =
    Math.max(
      1,
      Math.min(
        allowedMonths > 0
          ? allowedMonths
          : installmentsLeft,
        installmentsLeft || 1
      )
    )


  const loanPayment =
    selectedMonths * monthlyPayment

  const totalPayment =
    loanPayment + defaultAmount


  const loanStartDate =
    loan.loan_start_date
      ? new Date(loan.loan_start_date)
      : null


  const loanHasStarted =
    loanStartDate &&
    new Date() >= loanStartDate


  const payNow = async () => {

    if (!loanHasStarted) {

      setError(
        `Payments become available from ${formatDate(
          loan.loan_start_date
        )}.`
      )

      return
    }


    try {

      setPaying(true)
      setError('')


      const response = await axios.post(
        `${url}/pay/make-payment/${totalPayment}`,
        {},
        {
          headers: {
            Authorization:
              `Bearer ${localStorage.getItem('access_token')}`
          }
        }
      )


      if (response.data.error) {

        setError(
          response.data.error
        )

        return
      }


      if (!response.data.url) {

        setError(
          'Payment checkout could not be created.'
        )

        return
      }


      window.location.href =
        response.data.url


    } catch (err) {

      console.error(
        'Payment initialization error:',
        err
      )

      setError(
        err.response?.data?.detail ||
        err.response?.data?.error ||
        'Unable to initialize payment.'
      )

    } finally {

      setPaying(false)
    }
  }


  return (

    <div className="
      min-h-screen
      bg-[#F7F9FC]
      font-[Satoshi]
      text-gray-900
    ">

      <Navbar />


      <main className="
  lg:ml-[15em]
  min-w-0
  min-h-screen
  flex-1
  bg-[#F7F9FC]
  px-5
  pb-10
  pt-24
  sm:px-6
  lg:px-8
  lg:pt-8
">

  <div className="
    mx-auto
    max-w-[1500px]
  ">


        {/* PAGE HEADER */}

        <div className="
          mb-6
          flex
          flex-col
          gap-4
          sm:mb-8
          sm:flex-row
          sm:items-end
          sm:justify-between
        ">

          <div>
            <p className="
              text-sm
              font-semibold
              text-green-600
            ">
              REPAYMENTS
            </p>

            <h1 className="
              mt-1
              text-2xl
              sm:text-3xl
              font-bold
              tracking-tight
            ">
              Make a payment
            </h1>

            <p className="
              mt-2
              text-sm
              leading-6
              text-gray-500
            ">
              Manage your RentHub repayments from here.
            </p>
          </div>


            <div className="
              flex
              items-center
              gap-2
              bg-green-50
              text-green-700
              px-3
              py-2
              rounded-full
              text-xs
              font-bold
              w-fit
            ">

              <span className="
                w-2
                h-2
                rounded-full
                bg-green-500
              " />

              ACTIVE LOAN

            </div>

          </div>


          {/* BALANCE HERO */}

          <section className="
            bg-[#101828]
            rounded-3xl
            px-6
            py-7
            lg:px-8
            lg:py-8
            text-white
            shadow-sm
            mb-7
            overflow-hidden
            relative
          ">

            <div className="
              absolute
              w-72
              h-72
              rounded-full
              bg-green-500/10
              -right-20
              -top-36
            " />


            <div className="
              relative
              grid
              grid-cols-1
              md:grid-cols-3
              gap-6
            ">


              <div className="
                md:col-span-2
              ">

                <p className="
                  text-sm
                  text-gray-400
                ">
                  Outstanding balance
                </p>

                <p className="
                  text-3xl
                  lg:text-4xl
                  font-bold
                  mt-2
                ">
                  {formatCurrency(
                    outstandingBalance
                  )}
                </p>

                <p className="
                  text-sm
                  text-gray-400
                  mt-3
                ">
                  {installmentsLeft}{' '}
                  {installmentsLeft === 1
                    ? 'installment'
                    : 'installments'
                  } remaining
                </p>

              </div>


              <div className="
                md:border-l
                md:border-white/10
                md:pl-7
                flex
                flex-col
                justify-center
              ">

                <p className="
                  text-sm
                  text-gray-400
                ">
                  Monthly repayment
                </p>

                <p className="
                  text-2xl
                  font-bold
                  mt-2
                ">
                  {formatCurrency(
                    monthlyPayment
                  )}
                </p>

              </div>

            </div>

          </section>


          {/* MAIN GRID */}

          <div className="
            grid
            grid-cols-1
            lg:grid-cols-12
            gap-6
            items-start
          ">


            {/* PAYMENT PANEL */}

            <section className="
              lg:col-span-8
              bg-white
              border
              border-gray-200
              rounded-2xl
              shadow-sm
              p-6
              lg:p-8
            ">


              <div className="mb-7">

                <h2 className="
                  text-xl
                  font-bold
                ">
                  Payment details
                </h2>

                <p className="
                  text-sm
                  text-gray-500
                  mt-1
                ">
                  Choose how many monthly installments you want to settle.
                </p>

              </div>


              {/* MONTHS */}

              <div className="mb-7">

                <label
                  htmlFor="repayment-months"
                  className="
                    block
                    text-sm
                    font-semibold
                    text-gray-700
                    mb-2
                  "
                >
                  Number of installments
                </label>

                <select
                  id="repayment-months"
                  value={selectedMonths}
                  onChange={(e) =>
                    setSelectedMonths(
                      Number(e.target.value)
                    )
                  }
                  className="
                    w-full
                    h-[52px]
                    border
                    border-gray-300
                    rounded-xl
                    px-4
                    bg-white
                    text-gray-900
                    outline-none
                    transition
                    focus:border-green-500
                    focus:ring-4
                    focus:ring-green-50
                  "
                >

                  {Array.from(
                    {
                      length:
                        availableMonths
                    },
                    (_, index) =>
                      index + 1
                  ).map(month => (

                    <option
                      key={month}
                      value={month}
                    >
                      {month === 1
                        ? '1 monthly installment'
                        : `${month} monthly installments`
                      }
                    </option>

                  ))}

                </select>

              </div>


              {/* SUMMARY */}

              <div className="
                bg-[#F8FAFC]
                border
                border-gray-100
                rounded-2xl
                p-5
                lg:p-6
              ">

                <p className="
                  text-sm
                  font-bold
                  text-gray-800
                  mb-5
                ">
                  Payment summary
                </p>


                <div className="
                  space-y-4
                ">

                  <PaymentRow
                    title={
                      selectedMonths === 1
                        ? '1 installment'
                        : `${selectedMonths} installments`
                    }
                    value={
                      formatCurrency(
                        loanPayment
                      )
                    }
                  />


                  <PaymentRow
                    title="Default charges"
                    value={
                      formatCurrency(
                        defaultAmount
                      )
                    }
                    danger={
                      defaultAmount > 0
                    }
                  />


                  <div className="
                    border-t
                    border-gray-200
                    pt-5
                    mt-5
                  ">

                    <div className="
                      flex
                      items-end
                      justify-between
                      gap-4
                    ">

                      <span className="
                        text-sm
                        font-semibold
                        text-gray-600
                      ">
                        Total payment
                      </span>

                      <span className="
                        text-2xl
                        lg:text-3xl
                        font-bold
                        tracking-tight
                      ">
                        {formatCurrency(
                          totalPayment
                        )}
                      </span>

                    </div>

                  </div>

                </div>

              </div>


              {/* START DATE */}

              {!loanHasStarted && (

                <div className="
                  mt-5
                  bg-amber-50
                  border
                  border-amber-200
                  rounded-xl
                  px-5
                  py-4
                ">

                  <p className="
                    font-semibold
                    text-amber-900
                  ">
                    Repayment hasn't started yet
                  </p>

                  <p className="
                    text-sm
                    text-amber-700
                    mt-1
                  ">
                    You can begin making payments from{' '}
                    <strong>
                      {formatDate(
                        loan.loan_start_date
                      )}
                    </strong>.
                  </p>

                </div>

              )}


              {/* ERROR */}

              {error && (

                <div className="
                  mt-5
                  bg-red-50
                  border
                  border-red-200
                  rounded-xl
                  px-5
                  py-4
                  text-sm
                  text-red-600
                ">
                  {error}
                </div>

              )}


              {/* CTA */}

              <button
                type="button"
                onClick={payNow}
                disabled={
                  paying ||
                  !loanHasStarted
                }
                className={`
                  w-full
                  min-h-[56px]
                  mt-7
                  rounded-xl
                  font-bold
                  text-base
                  transition-all
                  flex
                  items-center
                  justify-center

                  ${
                    loanHasStarted &&
                    !paying

                      ? `
                        bg-green-600
                        hover:bg-green-700
                        active:bg-green-800
                        text-white
                        shadow-sm
                      `

                      : `
                        bg-gray-200
                        text-gray-400
                        cursor-not-allowed
                      `
                  }
                `}
              >

                {paying
                  ? 'Preparing secure checkout...'
                  : `Pay ${formatCurrency(
                      totalPayment
                    )}`
                }

              </button>


              <p className="
                text-xs
                text-center
                text-gray-400
                mt-3
              ">
                You will be redirected to our secure payment provider to complete your payment.
              </p>

            </section>


            {/* SIDE PANEL */}

            <aside className="
              lg:col-span-4
              space-y-5
            ">


              {/* LOAN DETAILS */}

              <div className="
                bg-white
                border
                border-gray-200
                rounded-2xl
                shadow-sm
                p-6
              ">

                <div className="
                  flex
                  justify-between
                  items-start
                  gap-4
                  mb-6
                ">

                  <div>

                    <p className="
                      text-xs
                      font-bold
                      uppercase
                      tracking-wider
                      text-green-600
                    ">
                      Loan details
                    </p>

                    <p className="
                      text-sm
                      text-gray-400
                      mt-1
                    ">
                      Application #{application.loan_application_id}
                    </p>

                  </div>

                </div>


                <div className="
                  bg-gray-50
                  rounded-xl
                  p-4
                  mb-6
                ">

                  <p className="
                    text-xs
                    uppercase
                    tracking-wide
                    font-semibold
                    text-gray-400
                  ">
                    Property
                  </p>

                  <p className="
                    text-sm
                    font-semibold
                    text-gray-800
                    leading-5
                    mt-2
                  ">
                    {application.property_address}
                  </p>

                </div>


                <div className="
                  divide-y
                  divide-gray-100
                ">

                  <InfoRow
                    label="Installments left"
                    value={`${installmentsLeft} of 12`}
                  />

                  <InfoRow
                    label="Loan started"
                    value={
                      formatDate(
                        loan.loan_start_date
                      )
                    }
                  />

                  <InfoRow
                    label="Next payment"
                    value={
                      formatDate(
                        loan.next_payment_date
                      )
                    }
                  />

                  <InfoRow
                    label="Loan ends"
                    value={
                      formatDate(
                        loan.loan_end_date
                      )
                    }
                  />

                </div>

              </div>


              {/* DEFAULT WARNING */}

              {defaultAmount > 0 && (

                <div className="
                  bg-red-50
                  border
                  border-red-100
                  rounded-2xl
                  p-5
                ">

                  <p className="
                    text-sm
                    font-bold
                    text-red-700
                  ">
                    Outstanding default charges
                  </p>

                  <p className="
                    text-2xl
                    font-bold
                    text-red-700
                    mt-2
                  ">
                    {formatCurrency(
                      defaultAmount
                    )}
                  </p>

                  <p className="
                    text-xs
                    leading-5
                    text-red-600
                    mt-2
                  ">
                    Default charges are included automatically in your next repayment.
                  </p>

                </div>

              )}


              {/* SUPPORT */}

              <div className="
                bg-[#101828]
                rounded-2xl
                p-5
                text-white
              ">

                <p className="
                  font-semibold
                ">
                  Need help?
                </p>

                <p className="
                  text-sm
                  text-gray-400
                  leading-6
                  mt-2
                ">
                  Contact RentHub support if you have an issue with your repayment or loan schedule.
                </p>

              </div>

            </aside>

          </div>

        </div>

      </main>

    </div>
  )
}



function PaymentRow({
  title,
  value,
  danger = false
}) {

  return (

    <div className="
      flex
      items-center
      justify-between
      gap-5
    ">

      <span className="
        text-sm
        text-gray-500
      ">
        {title}
      </span>

      <span className={`
        text-sm
        font-semibold

        ${
          danger
            ? 'text-red-600'
            : 'text-gray-900'
        }
      `}>
        {value}
      </span>

    </div>
  )
}



function InfoRow({
  label,
  value
}) {

  return (

    <div className="
      flex
      justify-between
      items-center
      gap-5
      py-4
      first:pt-0
      last:pb-0
    ">

      <span className="
        text-sm
        text-gray-500
      ">
        {label}
      </span>

      <span className="
        text-sm
        font-semibold
        text-gray-900
        text-right
      ">
        {value}
      </span>

    </div>
  )
}



function formatCurrency(amount) {

  return new Intl.NumberFormat(
    'en-NG',
    {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).format(
    Number(amount || 0)
  )
}



function formatDate(date) {

  if (!date) {
    return '—'
  }

  return new Date(
    date
  ).toLocaleDateString(
    'en-GB',
    {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }
  )
}